import { map, catchError } from "rxjs/operators";
import { throwError } from "rxjs";
import { axiosRequest } from "@/utils/utils-axios";
import { type ResponseData } from "@/types/app";
import { type UserContent } from "@/types/content";
import { type ChangePasswordDto, type UpdateProfileDto } from "@/types/dto";

export const SearchUsers = (query: string) => {
  return axiosRequest({
    url: "/api/users/search",
    method: "get",
    params: {
      searchInput: query,
    },
  }).pipe(
    map((response) => response.data as ResponseData<UserContent[]>),
    map((response) => response.data),
    catchError((error) => {
      return throwError(() => error);
    })
  );
};

export const UpdateUserProfile = (data: UpdateProfileDto) => {
  return axiosRequest({
    url: "/api/users/profile",
    method: "put",
    data,
  }).pipe(
    map((response) => response.data as ResponseData<UserContent>),
    map((response) => response.data),
    catchError((error) => {
      return throwError(() => error);
    })
  );
};

export const ChangeUserPassword = (data: ChangePasswordDto) => {
  return axiosRequest({
    url: "/api/users/password",
    method: "put",
    data,
  }).pipe(
    map((response) => response.data as ResponseData<UserContent>),
    map((response) => response.data),
    catchError((error) => {
      return throwError(() => error);
    })
  );
};
